<ng-container *ngIf="vm$ | async as vm">
  <ng-container *ngIf="vm.activity">
    <div class="boaheader">
      <h1 class="head1">BOA-{{vm.activity.Id}} : {{vm.activity.Subject}}</h1>
      <button type="button" (click)="cancel()" class="btn-icon fa fa-times fa-2x"></button>
    </div>

    <h2 class="head4 boadescription">{{vm.activity.Description}}</h2>

    <div class="documenten">

      <a tabindex="0" (click)="openDocument(attachment)" class="document" *ngFor="let attachment of vm.activity.Attachments">
        <i class="icon-file"></i>
        <span>{{attachment.Subject}} ({{attachment.Extensie}})</span>
      </a>

    </div>

    <div class="afzender">
      <label class="bold">Afzender</label>
      <span>{{vm.activity.Customer.FirstName}} {{vm.activity.Customer.LastName}}</span>
    </div>

  </ng-container>
</ng-container>